import { zodResolver } from "@hookform/resolvers/zod"
import { scrollToElementForm } from "@lib/utils"
import clsx from "clsx"
import React, { useEffect, useState, useRef } from "react"
import { FormProvider, useForm } from "react-hook-form"
import "../assets/styles/form.scss"
import { Link, navigate } from "gatsby"
import { servicesURL } from "@lib/urls"
import ResponseMessage from "./ResponseMessage"
import { Modal } from "react-bootstrap"
import { PageLinks } from "@common/site/page-static-links"
import CloseIcon from "@components/icons/CloseIcon"
import { useGlobalStore } from "@stores/globalStore"

const Form = ({
  defaultValues,
  children,
  onSubmit,
  validationSchema,
  className,
  successMsg,
  noScrollOnSuccess,
  formname,
  issale
}) => {
  const myRef = useRef(null);
  const {showSuccessMsg, setShowSuccessMsg} = useGlobalStore()
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  // init react-hook-form
  const formMethods = useForm({
    defaultValues,
    resolver: zodResolver(validationSchema),
  })

  const {
    handleSubmit,
    // watch,
    formState,
    // formState: { errors },
    reset,
  } = formMethods
  useEffect(() => {
    // reset form and show success after onSubmit is run
    if (formState.isSubmitSuccessful) {
      if(formname === "career"){
      setShowSuccessMsg(true)
      }
      reset()
      if (typeof window !== "undefined") {
        try {
          window?.__adroll?.record_user({ "adroll_segments": "02c6d466" });
        } catch (err) {
          console.error('Error recording AdRoll user:', err);
        }
      }

      if (!noScrollOnSuccess) {
        scrollToElementForm(myRef, 200)
        if (formname === "bookaviewing" && issale) {
          setTimeout(() => {
            handleShow()
          }, 2000)
        }
        else if(formname === "registerintrest"){
          navigate("/", {
            state: { open: true },
          })
        }

      }

      setTimeout(() => {
        setShowSuccessMsg(false)
        if (formname === "bookaviewing" && issale) {
        }
        else if(formname === "registerintrest"){
          navigate("/", {
            state: { open: true },
          })
        }
        else if(formname === "bright") {
          
        }
        else {
          navigate(servicesURL)
        }
      }, 10000)
    }
  }, [formState, reset])

  const onFormSubmit = async (data) => {
    await onSubmit(data)
  }



  return (
    <FormProvider {...formMethods}>
      <div ref={myRef} id="form-success-msg">
        {showSuccessMsg && (
          <ResponseMessage message={successMsg} type="success" />
        )}
      </div>
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className={clsx("custom-form", className)}
      >
        {children}
      </form>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        backdrop="static"
        fullscreen="md"
        className="office-contact-modal"
      >
        <Modal.Body className="office-contact-modal-body">
          <div className="office-contact-modal-header">
            <div className="content-section">
              <h3 className="title">Need Help With Mortgage?</h3>
              <p className="description">
                Step Forward Into Easy Financing - Secure Your Mortgage Today!
              </p>
            </div>
            <CloseIcon onClick={handleClose} />
          </div>
          <Link to={"/property-services/mortgages/#Mortgage"} className="button button-orange">
          <span>Start Your Pre-approval</span>
        </Link>
        </Modal.Body>
      </Modal>
    </FormProvider>
  )
}

export default Form
